import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GenericDialogComponent } from 'src/app/modules/shared/generic-dialog/generic-dialog.component';
import { LanguageService } from 'src/app/modules/shared/services/language.service';

@Component({
  standalone: false,
  selector: 'app-accept-comment-estimate-dialog',
  templateUrl: './accept-comment-estimate-dialog.component.html',
  styleUrls: ['./accept-comment-estimate-dialog.component.css']
})
export class AcceptCommentEstimateDialog implements OnInit {

  variables: any;
  local_data: any;
  input: boolean = false;
  message: string = '';
  formGroup: any;
  isCompleteOrIncomplete: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AcceptCommentEstimateDialog>,
    private languageService: LanguageService,
    private _formBuilder: FormBuilder,
  ) {
    this.local_data = { data };
  }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });

    this.formGroup = this._formBuilder.group({
      commentaryCtrl: ['', this.local_data.data.isRequired ? Validators.required : !Validators.required]
    });
  }

  doActionIsComplete(value: boolean) {
    this.input = true
    this.dialogRef.close({
      data: this.input,
      isComplete: value,
      isIncomplete: !value
    });
  }

  doAction() {
    if (this.formGroup.valid) {
      const commentary = this.formGroup.get('commentaryCtrl')?.value;
      this.dialogRef.close({
        accept: this.local_data.data.accept,
        commentary: commentary
      });
    }
    else {
      // Mark all fields as touched to show validation errors
      this.formGroup.markAllAsTouched();
    }
  }
}
